var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5 16.5H16.5V21.5C16.5 22.05 16.05 22.5 15.5 22.5C14.95 22.5 14.5 22.05 14.5 21.5V16.5H9.5C8.95 16.5 8.5 16.05 8.5 15.5C8.5 14.95 8.95 14.5 9.5 14.5H14.5V9.5C14.5 8.95 14.95 8.5 15.5 8.5C16.05 8.5 16.5 8.95 16.5 9.5V14.5H21.5C22.05 14.5 22.5 14.95 22.5 15.5C22.5 16.05 22.05 16.5 21.5 16.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddWhite);
export default __webpack_public_path__ + "static/media/add_white.c77118d0fb0ca081acb9381ea4f7648a.svg";
export { ForwardRef as ReactComponent };